module.exports = __webpack_public_path__ + "static/media/payment-methods.f07d1fa4.png";